import styled from 'styled-components';

export const GroupStyle = styled.div`
  position: relative;
  width: 100%;
  min-height: 130px;
  display: flex;
  overflow-x: auto;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  border-left: 1px solid ${({ theme }) => theme.palette.divider};
  border-right: 1px solid ${({ theme }) => theme.palette.divider};
`;
